import { BaseModel } from './BaseModel';

export class ServerTemplateTask extends BaseModel {
    public id = '';
    public sequenceId = -1;
    public action = '';
    public payload = '';
    public timeOffset = -1;
    public createdAt = '';
    public updatedAt = '';
}
